import { Formik } from 'formik'

import { InviteForm } from './form.component'
import { inviteAccountScannerSchema } from 'src/common/validations'
import { IAccountScannerCreateForm } from 'src/types'
import { useSendAccountScannerInvite } from 'src/hooks'

interface IProps {
  handleSelectItem: (id: string) => void
  handleClose: () => void
}

export const FormWrapper = ({ handleSelectItem, handleClose }: IProps) => {
  const { mutateAsync: inviteScanner } = useSendAccountScannerInvite()

  const handleSubmit = async (values: IAccountScannerCreateForm) => {
    const resp = await inviteScanner(values)
    if (!resp) return

    handleSelectItem(resp.id)
    handleClose()
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={inviteAccountScannerSchema}
      initialValues={{ email: '' }}
    >
      <InviteForm />
    </Formik>
  )
}
